<template>
  <section
    class="component-ab0f2fd5"
    resmed-component-name="feature_background_icon_title"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
      'background-size': acf.layout['background-size'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-md-9 col-xl-8 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>

            <h1
              v-if="acf.layout['heading-tag'] === 'h1'"
              v-html="acf.headline"
            ></h1>
            <h2
              v-if="acf.layout['heading-tag'] === 'h2'"
              v-html="acf.headline"
            ></h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ab0f2fd5", // feature_background_icon_title
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ab0f2fd5 {
  background-position: center center;
  background-repeat: no-repeat;
  padding: 5rem 0;

  &:first-of-type {
    @media (min-width: 768px) {
      padding: 6rem 0 5rem 0;
    }

    @media (min-width: 992px) {
      padding: 12rem 0 5rem 0;
    }

    @media (min-width: 1200px) {
      padding: 12.5rem 0 4rem 0;
    }
  }
}

.component {
  h1,
  h2 {
    position: relative;
    text-align: center;
    margin: 0;

    @extend %eyebrow-center;
  }
}
</style>